module.exports = __webpack_public_path__ + "img/8-iBilleteUX.334da355.jpg";